module.exports = __webpack_public_path__ + "img/banner_en.f2bb6b14.jpg";